import { get } from 'lodash'
import { required } from 'utils/validation'

const validate = values => {
  const errors = {}

  errors.awardLevel = {
    value: required(get(values, 'awardLevel.value'))
  }

  return errors
}

export default validate
